import type { CSSProperties, MouseEventHandler } from "react";

import style from "./style.module.css";

interface AvatarProps {
  className?: string;
  charsClassName?: string;
  size?: string;
  theme?: string;
  noBorder?: boolean;
  doubleBorder?: boolean;
  doubleBorderColor?: string;
  name?: string;
  src?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
  singleCharacterNameInitial?: boolean;
}

const Avatar = ({
  className,
  charsClassName,
  size,
  theme,
  noBorder,
  doubleBorder,
  doubleBorderColor = "white",
  name = "",
  src,
  onClick,
  singleCharacterNameInitial
}: AvatarProps) => {
  /* Get initials from first name and last name. Eg: 'ABC DEF GHI' will return 'AG'*/
  const nameInitials = () => {
    let initials = name.match(/\b\w/g) || [];
    const label = (
      (initials.shift() || "") + (initials.pop() || "")
    ).toUpperCase();
    return singleCharacterNameInitial === true ? label[0] : label;
  };

  const divStyle: CSSProperties = {
    backgroundImage: src ? `url("${src}")` : undefined,
    border: noBorder ? "0px" : undefined,
    width: size,
    height: size,
    minWidth: size,
    boxShadow: doubleBorder ? `0 0 0 2px ${doubleBorderColor}` : "none"
  };

  return (
    <div
      className={`${style.avatar} ${theme ? style[theme] : undefined} ${className}`}
      data-has-double-border={doubleBorder}
      style={divStyle}
      onClick={onClick}
      data-testid="Avatar"
    >
      {!src && (
        <div className={`${style.chars} ${charsClassName}`}>
          {nameInitials()}
        </div>
      )}
    </div>
  );
};

export default Avatar;
